var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timer-event-table-wrap portal-compact-list-shell" },
    [
      _c(
        "div",
        [
          _c(
            "v-data-table",
            {
              staticClass: "timer-events-table portal-compact-table",
              attrs: {
                id: "timer-events-table",
                headers: _vm.headers,
                "sort-by": "dateTime",
                "sort-desc": true,
                "must-sort": true,
                items: _vm.fixedUpEvents,
                "disable-pagination": true,
                "hide-default-footer": true,
                "mobile-breakpoint": 200
              },
              scopedSlots: _vm._u([
                {
                  key: "item.invoiced",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      item.invoiceId
                        ? _c(
                            "portal-status-pill",
                            {
                              attrs: {
                                background: "var(--v-success_10-base)",
                                color: "var(--v-success-base)"
                              },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.openInvoice(item.invoiceId)
                                }
                              }
                            },
                            [_vm._v(" Billed ")]
                          )
                        : _c("span", { staticClass: "portal-cell-muted" }, [
                            _vm._v("—")
                          ])
                    ]
                  }
                },
                {
                  key: "item.timerStart",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "portal-cell-truncate",
                          attrs: { title: item.dateDisplay }
                        },
                        [_vm._v(" " + _vm._s(item.dateDisplay) + " ")]
                      )
                    ]
                  }
                },
                {
                  key: "item.timeWorkedSortable",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "time-worked text-end",
                          staticStyle: { "text-wrap": "none" }
                        },
                        [_vm._v(" " + _vm._s(item.timeWorked) + " ")]
                      )
                    ]
                  }
                },
                {
                  key: "item.projectName",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "portal-cell-truncate",
                          attrs: { title: item.projectName }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("empty")(item.projectName)) +
                              " "
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "item.deliverableOrTicket",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "portal-cell-truncate portal-cell-primary",
                          attrs: { title: item.deliverableOrTicket }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("empty")(item.deliverableOrTicket)
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "item.notes",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "portal-cell-truncate portal-cell-muted",
                          attrs: { title: item.notes }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm._f("empty")(item.notes)) + " "
                          )
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "no-data",
                  fn: function() {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("timetrack.time-entries.no-timetrack")
                          ) +
                          " "
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("template", { slot: "body.append" }, [
                _c("tr", [
                  _c("td", { staticClass: "portal-list-priority-compact" }),
                  _c("th", { staticClass: "total text-end" }, [
                    _c("span", { staticClass: "font-14" }, [
                      _vm._v(_vm._s(this.$t("timetrack.time-entries.total")))
                    ])
                  ]),
                  _c("td", [
                    _c("div", { staticClass: "time-worked text-end" }, [
                      _vm._v(_vm._s(_vm.timeWorkedTotal))
                    ])
                  ]),
                  !_vm.hideProject
                    ? _c("td", { staticClass: "portal-list-priority-medium" })
                    : _vm._e(),
                  _c("td"),
                  _c("td", { staticClass: "portal-list-priority-low" })
                ])
              ])
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }